export default __webpack_public_path__ + "static/media/TF_04.8bfab1b4.png";